import React from "react";
import { TableRow, TableCell, Box, Typography } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";

const ClientOrderItem = ({ order, currencyCode, isFirst }) => {
  const { t } = useTranslation();
  const created = order?.createdAt
    ? moment(order.createdAt).format("DD.MM.YYYY HH:mm:ss")
    : "";
  const paymentMethod =
    order?.paymentord?.method || order?.payment?.method || "";
  const employee = order?.additionalInfo?.authenticatedUser?.employee;
  const empName = employee
    ? ` [ ${employee.firstName || ""} ${employee.lastName || ""} ]`
    : "";

  const fmt = (n) =>
    n !== undefined && n !== null && n !== ""
      ? `${Number(n).toFixed(2)} ${currencyCode || ""}`
      : "";

  const products = Object.values(order?.products || {});

  return (
    <>
      <TableRow sx={{ backgroundColor: "#FFF3E0" }}>
        <TableCell>{order?.externalOrderId}</TableCell>
        <TableCell>
          {t("pages.dsokOrders.paymentMethods." + paymentMethod)}
        </TableCell>
        <TableCell>
          {created}{" "}
          {empName && (
            <span style={{ fontSize: "12px", color: "#E44A77" }}>
              {empName}
            </span>
          )}
        </TableCell>
        <TableCell align="right">{fmt(order?.grandTotalWithoutVat)}</TableCell>
        <TableCell align="right">{fmt(order?.vatTotal)}</TableCell>
        <TableCell align="right">{fmt(order?.grandTotal)}</TableCell>
      </TableRow>
      {products.length > 0 && (
        <TableRow>
          <TableCell colSpan={6} sx={{ py: 0 }}>
            <Box sx={{ px: 2, pb: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {t("pages.clientOrdersList.products")}
              </Typography>
              <table style={{ width: "100%", fontSize: 13 }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }}>
                      {t("pages.clientOrdersList.sku")}
                    </th>
                    <th style={{ textAlign: "left" }}>
                      {t("pages.dsokReports.productName")}
                    </th>
                    <th style={{ textAlign: "right" }}>
                      {t("pages.dsokReports.quantity")}
                    </th>
                    <th style={{ textAlign: "right" }}>
                      {t("pages.dsokReports.itemPrice")}
                    </th>
                    <th style={{ textAlign: "right" }}>
                      {t("pages.dsokReports.base")}
                    </th>
                    <th style={{ textAlign: "right" }}>
                      {t("pages.dsokReports.vatRate")}
                    </th>
                    <th style={{ textAlign: "right" }}>
                      {t("pages.dsokReports.vatValue")}
                    </th>
                    <th style={{ textAlign: "right" }}>
                      {t("pages.dsokReports.total")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((p, idx) => (
                    <tr key={idx}>
                      <td>{p.sku}</td>
                      <td>{p.name}</td>
                      <td style={{ textAlign: "right" }}>{p.qty}</td>
                      <td style={{ textAlign: "right" }}>{fmt(p.itemPrice)}</td>
                      <td style={{ textAlign: "right" }}>{fmt(p.vatBase)}</td>
                      <td style={{ textAlign: "right" }}>{p.vatRate} %</td>
                      <td style={{ textAlign: "right" }}>{fmt(p.vat)}</td>
                      <td style={{ textAlign: "right" }}>
                        {fmt(p.totalPrice)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default ClientOrderItem;
